var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForkAndKnife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Knife-fork-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.706,8.044c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0l-1.6,1.6L18.11,7.653l1.599-1.61 c0.389-0.392,0.387-1.025-0.004-1.415c-0.392-0.389-1.024-0.386-1.415,0.004l-1.6,1.61l-0.583-0.58l1.609-1.609 c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L13.18,5.762c-0.324,0.324-0.58,0.7-0.766,1.106l-1.82-1.819 C7.597,1.979,3.869,3.927,2.316,5.387C2.119,5.572,2.005,5.83,2.001,6.1C1.997,6.371,2.103,6.631,2.294,6.823l1.841,1.841 c0.391,0.391,1.023,0.391,1.414,0c0.391-0.39,0.391-1.023,0-1.414L4.513,6.213C5.592,5.52,7.507,4.749,9.171,6.454l6.113,6.112 l-2.21,2.21L7.96,9.661c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l1.312,1.312l-5.08,5.085 c-1.034,1.034-1.034,2.717,0,3.751c0.517,0.517,1.196,0.775,1.875,0.775s1.358-0.259,1.876-0.775l5.08-5.085l5.085,5.085 c0.517,0.517,1.196,0.775,1.875,0.775c0.679,0,1.358-0.258,1.875-0.775c0.501-0.501,0.777-1.167,0.777-1.875 s-0.276-1.375-0.777-1.875l-3.619-3.619l0.58-0.58c0.188-0.188,0.293-0.442,0.293-0.707c0-0.234-0.094-0.453-0.243-0.632 c0.413-0.187,0.799-0.439,1.128-0.768L21.706,8.044z M14.594,7.176l0.099-0.099l2.584,2.567l-0.108,0.108 c-0.359,0.36-0.85,0.537-1.353,0.518l-1.739-1.738C14.059,8.028,14.235,7.536,14.594,7.176z M5.115,19.809 c-0.254,0.255-0.669,0.254-0.923,0c-0.254-0.254-0.254-0.668,0-0.923l5.08-5.084l0.922,0.922L5.115,19.809z M19.031,18.886 c0.254,0.254,0.254,0.668,0,0.923c-0.255,0.254-0.668,0.254-0.922,0l-3.62-3.62l0.923-0.923L19.031,18.886z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForkAndKnife);
export default __webpack_public_path__ + "static/media/fork-and-knife.c885942aa46a4e395a33efdb82f77ba9.svg";
export { ForwardRef as ReactComponent };